import { ApplicationRootState } from 'store/types';

const selectBackOfficeEnterpriseSites = (state: ApplicationRootState) =>
  state.backOfficeEnterpriseSites;

export default selectBackOfficeEnterpriseSites;
